module.exports = __webpack_public_path__ + "img/qrcode_1.7209fd69.png";